import { divideRounded } from '../shared/money';

/**
 * What the guest paid for `quantity` of a bill line (item refund, ADR-0051): its share of the
 * line total, grossed up by the bill's service charge, tax and rounding (total ÷ subtotal),
 * rounded half-up to whole minor units.
 */
export function lineRefundMinor(
  lineTotalMinor: number,
  quantity: number,
  lineQuantity: number,
  bill: { subtotal_minor: number; total_minor: number },
): number {
  const gross = bill.subtotal_minor > 0;
  const num = BigInt(lineTotalMinor) * BigInt(quantity) * BigInt(gross ? bill.total_minor : 1);
  const den = BigInt(lineQuantity) * BigInt(gross ? bill.subtotal_minor : 1);
  return Number(divideRounded(num, den, 'half_up'));
}
